module.exports = __webpack_public_path__ + "img/ic-twitter.2e56b202.svg";